import { FC } from 'react';
import { TooltipProps } from 'recharts';
import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

import { dateTickFormatter } from 'features/Dashboard/common';

import GraphTooltip from '../../../GraphTooltip';
import locales from './locales';

const BarLineGraphTooltip: FC<TooltipProps<ValueType, NameType>> = ({
  ...props
}) => {
  const { active, payload } = props;

  if (!active || !payload?.length) {
    return null;
  }

  const [anyDataKey] = payload;

  const { date, fullData } = anyDataKey?.payload || {};

  if (!fullData) {
    return null;
  }

  const balanceValue = fullData.monthStartBalance;
  const { earnings } = fullData;
  const { spendings } = fullData;

  const formattedDate = dateTickFormatter(date);

  // @ts-expect-error anyDataKey is possibly 'undefined'.
  if (anyDataKey.dataKey === 'monthStartBalance') {
    return (
      <GraphTooltip
        labels={[
          {
            title: locales.formatString(locales.balance, {
              from: formattedDate,
            }),
            value: balanceValue,
          },
        ]}
        {...props}
      />
    );
  }

  return (
    <GraphTooltip
      labels={[
        {
          title: locales.earnings,
          value: earnings,
        },
        {
          title: locales.spendings,
          value: spendings,
        },
      ]}
      marginLeft="-15px"
      vertical
      {...props}
    />
  );
};

export default BarLineGraphTooltip;
